import type { Places } from '~/types/places';

const PLACES_PROFILE: Places = {
  business: {
    bank: -15,
    government: -10,
    office: -15,
  },
  education: {
    childcare: -10,
    high_school: -5,
    library: 0,
    primary: -5,
    university: 0,
  },
  essentials: {
    electricity: 10,
    gas: 5,
    sewers: 5,
    waste: 5,
    water: 15,
  },
  food: {
    bakery: 10,
    coffee: 10,
    fast_food: 7,
    restaurant: 10,
  },
  health: {
    clinic: 5,
    dentist: -5,
    hospital: -5,
    pharmacy: 5,
  },
  nature: {
    beach: 10,
    forest: 10,
    lake: 15,
    mountain: 7,
    park: 10,
    river: 10,
  },
  religion: {
    church: 0,
    mosque: 0,
  },
  shops: {
    grocery: 12,
    mall: -5,
  },
  soil: {
    clay: 10,
    loam: 15,
    peat: 10,
    salt: -5,
    sand: 15,
    silt: 10,
  },
  sport: {
    gym: -5,
    pool: -10,
  },
  telecom: {
    cable_tv: -5,
    fiber_optic: 0,
    network_4g: 10,
    network_5g: 5,
    phone: 7,
  },
  transport: {
    airport: -5,
    bus: 10,
    ferry: 7,
    gas_station: 10,
    metro: 5,
    parking: 15,
    taxi: 10,
    train: 5,
    tram: -5,
  },
};

export default PLACES_PROFILE;
